import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'
import { ENV_TYPE, SHIPPING_ADDRESS_OPTIONS } from '../../../../lib/constants'

export function getInitialState(props = serverProps) {
  const {
    addressEntryFormat = {},
    addresses = [],
    env = '',
    recipientData = {},
  } = props

  const { address = {}, shippingRequired = false } = recipientData
  const defaultAddress =
    (addresses.length && addresses) || address.addresses || []
  const selectedShippingAddress =
    (env === ENV_TYPE.DONATE && !shippingRequired
      ? {}
      : defaultAddress.find(addr => !!addr.isDefault)) ||
    address.selectedShippingAddress ||
    defaultAddress[0] ||
    {}

  const initialState = {
    env,
    addressEntryFormat,
    addresses: defaultAddress,
    selectedShippingAddress,
    selectedBillingAddress:
      defaultAddress.find(addr => !!addr.isDefault) || defaultAddress[0] || {},
    newBillingAddress: {},
    newShippingAddress: {},
    newTravelRuleAddress: {},
    shakeBillingLabel: false,
    shippingAddressChecked: false,
    shippingAddressCheckboxAttempted: false,
    shippingType: '',
    addressRefetched: false,
  }
  return initialState
}

export default (state = getInitialState(serverProps), action) => {
  switch (action.type) {
    case types.EXTERNAL.TOGGLE_SHARE_ADDRESS:
      return {
        ...state,
        selectedShippingAddress: action.data.shouldShareAddress
          ? state.addresses.find(address => !!address.isDefault) ||
            state.addresses[0] ||
            {}
          : {},
      }

    case types.EXTERNAL.RECEIVED_DATA:
      return getInitialState({ ...state, ...action.data })

    case types.USER.CHANGE_BILLING_ADDRESS_ENTRY_FIELD:
      const newBillingAddress = {
        ...state.newBillingAddress,
        [action.data.field]: action.data.value,
      }
      return {
        ...state,
        newBillingAddress,
      }

    case types.USER.CHANGE_SHIPPING_ADDRESS_ENTRY_FIELD:
      const newShippingAddress = {
        ...state.newShippingAddress,
        [action.data.field]: action.data.value,
      }
      return {
        ...state,
        newShippingAddress,
      }

    case types.USER.CHANGE_TRAVEL_RULE_ADDRESS_ENTRY_FIELD:
      const newTravelRuleAddress = {
        ...state.newTravelRuleAddress,
        [action.data.field]: action.data.value,
      }
      return {
        ...state,
        newTravelRuleAddress,
      }

    case types.USER.CHANGE_SELECTED_SHIPPING_ADDRESS:
      return {
        ...state,
        selectedShippingAddress:
          state.env === ENV_TYPE.PPSHOPS &&
          state.shippingType === 'NOT_APPLICABLE' &&
          action.data.id === SHIPPING_ADDRESS_OPTIONS.NO_ADDRESS_NEEDED
            ? { id: SHIPPING_ADDRESS_OPTIONS.NO_ADDRESS_NEEDED }
            : state.addresses.find(address => address.id === action.data.id) ||
              {},
      }

    case types.USER.NO_SELECTED_SHIPPING_ADDRESS:
      return {
        ...state,
        selectedShippingAddress: {},
      }

    case types.USER.CHANGE_SHIPPING_ADDRESS_CHECKBOX:
      return {
        ...state,
        shippingAddressChecked: action.data.checked,
        shippingAddressCheckboxAttempted: true,
      }

    case types.TRANSACTION.SUBMITTING_RECIPIENT:
    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
    case types.TRANSACTION.CANCELLED_TRANSACTION:
      // reset checkbox to unchecked here, otherwise the value will stay in store,
      return {
        ...state,
        shippingAddressChecked: false,
        shippingAddressCheckboxAttempted: false,
      }

    case types.USER.CHANGE_SELECTED_BILLING_ADDRESS:
      return {
        ...state,
        selectedBillingAddress:
          state.addresses.find(address => address.id === action.data.id) || {},
      }

    case types.ADDRESS.ADDED_SHIPPING_ADDRESS:
      return {
        ...state,
        addresses: action.data.addresses,
        selectedShippingAddress:
          action.data.addresses.find(
            address => address.id === action.data.id
          ) || {},
        newShippingAddress: {},
      }

    case types.ADDRESS.ADDED_BILLING_ADDRESS:
      return {
        ...state,
        addresses: action.data.addresses,
        selectedBillingAddress:
          action.data.addresses.find(
            address => address.id === action.data.id
          ) || {},
        newBillingAddress: {},
      }

    case types.ADDRESS.NO_BILLING_ADDRESS:
      return {
        ...state,
        shakeBillingLabel: action.shakeBillingLabel,
      }

    case types.TRANSACTION.RECEIVED_FUNDING_OPTIONS: {
      return {
        ...state,
        shippingType: action.data.shippingType,
        selectedShippingAddress:
          state.env === ENV_TYPE.PPSHOPS &&
          action.data.shippingType === 'NOT_APPLICABLE' &&
          state.selectedShippingAddress.id !==
            SHIPPING_ADDRESS_OPTIONS.NO_ADDRESS_NEEDED &&
          !state.addressRefetched
            ? { id: SHIPPING_ADDRESS_OPTIONS.NO_ADDRESS_NEEDED }
            : state.selectedShippingAddress,
      }
    }

    case types.TRANSACTION.REFETCHED_FUNDING_OPTIONS: {
      return {
        ...state,
        shippingType: action.data.shippingType,
        addressRefetched: true,
      }
    }

    default:
      return state
  }
}
